import Stack from "./component-library310.mjs";
import assignMergeValue from "./component-library330.mjs";
import baseFor from "./component-library331.mjs";
import baseMergeDeep from "./component-library332.mjs";
import isObject from "./component-library234.mjs";
import keysIn from "./component-library329.mjs";
import safeGet from "./component-library333.mjs";
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
export {
  baseMerge as default
};
